var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14V8.66667C10.5 8.48986 10.4298 8.32029 10.3047 8.19526C10.1797 8.07024 10.0101 8 9.83333 8H7.16667C6.98986 8 6.82029 8.07024 6.69526 8.19526C6.57024 8.32029 6.5 8.48986 6.5 8.66667V14",
    stroke: "black",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6.66648C2.49995 6.47253 2.54222 6.2809 2.62386 6.10496C2.70549 5.92902 2.82453 5.77301 2.97267 5.64782L7.63933 1.64848C7.87999 1.44509 8.1849 1.3335 8.5 1.3335C8.8151 1.3335 9.12001 1.44509 9.36067 1.64848L14.0273 5.64782C14.1755 5.77301 14.2945 5.92902 14.3761 6.10496C14.4578 6.2809 14.5 6.47253 14.5 6.66648V12.6665C14.5 13.0201 14.3595 13.3592 14.1095 13.6093C13.8594 13.8593 13.5203 13.9998 13.1667 13.9998H3.83333C3.47971 13.9998 3.14057 13.8593 2.89052 13.6093C2.64048 13.3592 2.5 13.0201 2.5 12.6665V6.66648Z",
    stroke: "black",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.66c97ade340bd0dcc096862c630fd680.svg";
export { ForwardRef as ReactComponent };